module.exports = __webpack_public_path__ + "img/user-outlined-blue.d3c38762.svg";